/**
 * Product files in the R2 bucket 3acolor-images. Shared with the Worker, which
 * writes the files and puts the URLs in structured data, so both halves agree on
 * where a file lives.
 *
 * Photos are two WebP files per product, converted in the admin's browser before
 * upload: `lg` for the product page and `sm` for cards and lists. Technical data
 * sheets are one PDF per product, uploaded as-is. The bucket is served by
 * Cloudflare's CDN at IMAGE_ORIGIN, so neither costs a Worker request.
 */
export const IMAGE_ORIGIN = 'https://img.3acolor.com'

export type ImageSize = 'lg' | 'sm'

/** Longest edge in pixels. Photos are scaled down to fit, never up or cropped. */
export const IMAGE_MAX_EDGE: Record<ImageSize, number> = { lg: 1600, sm: 600 }

/** Upload limit per file, after conversion. A 1600 px WebP is well under this. */
export const IMAGE_MAX_BYTES = 3 * 1024 * 1024

/** R2 object key for one size of a product photo. */
export function imageKey(image: string, size: ImageSize): string {
  return `products/${image}-${size}.webp`
}

/** Upload limit for a technical data sheet. Supplier PDFs are a few hundred KB. */
export const DATASHEET_MAX_BYTES = 10 * 1024 * 1024

/** R2 object key for a product's technical data sheet. */
export function datasheetKey(datasheet: string): string {
  return `datasheets/${datasheet}.pdf`
}
